import React from 'react';
import { Card } from '../../../../components/ui/Card';
import { Input } from '../../../../components/ui/Input';
import { Button } from '../../../../components/ui/Button/Button';
import { cn } from '../../../../utils/cn';

interface CampaignTargetingProps {
  data: any;
  onChange: (field: string, value: any) => void;
  errors: Record<string, string>;
}

export const CampaignTargeting: React.FC<CampaignTargetingProps> = ({ data, onChange, errors }) => {
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-bold text-neutral-900 dark:text-neutral-100 mb-2">
          Campaign Targeting
        </h2>
        <p className="text-neutral-600 dark:text-neutral-400">
          Define your target audience and criteria
        </p>
      </div>

      <Card className="p-6">
        <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100 mb-4">
          Target Criteria
        </h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2">
              Job Titles
            </label>
            <Input
              placeholder="e.g., CEO, Marketing Director, VP Sales..."
              className="w-full"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2">
              Industries
            </label>
            <Input
              placeholder="e.g., Technology, Healthcare, Finance..."
              className="w-full"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2">
                Company Size
              </label>
              <select className="w-full px-3 py-2 border border-neutral-200 dark:border-neutral-700 rounded-md bg-white dark:bg-neutral-800 text-neutral-900 dark:text-neutral-100">
                <option value="">Any size</option>
                <option value="1-10">1-10 employees</option>
                <option value="11-50">11-50 employees</option>
                <option value="51-200">51-200 employees</option>
                <option value="201-1000">201-1000 employees</option>
                <option value="1000+">1000+ employees</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2">
                Location
              </label>
              <Input
                placeholder="e.g., United States, Europe..."
                className="w-full"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2">
              Estimated Target Size
            </label>
            <Input
              type="number"
              placeholder="Number of prospects..."
              className="w-full"
            />
          </div>
        </div>
      </Card>
    </div>
  );
}; 